<div class="ion-text-center">
    <ion-text>Wie gut konntest Du Deinen Vorsatz <b>"{{text}}"</b> einhalten?</ion-text>
    <plugin-rating-bar [(rating)]="rating" [titles]="['Überhaupt nicht', 'Selten', 'Manchmal', 'Häufig', 'Überwiegend', 'Fast immer', 'Immer']" [readonly]="readOnly"></plugin-rating-bar>
</div>
